import React, { useState, useEffect, useCallback } from "react";
import { connect } from 'react-redux';
import { avatar, trashIcon } from "../../../assets/media/chat/ChatIcons";
import { orderService } from "../../../services/order";
import { withRouter } from 'react-router-dom';
import ConfirmAlertForDelete from 'components/ThemeComponents/confirmAlertForDelete';
import { confirmAlert } from 'react-confirm-alert';
import { alertActions } from '../../../redux/actions/alert-actions';
import './ChatModule.css';

function Lightbox({ open, images, index, onClose, onPrev, onNext }) {
  if (!open) return null;

  return (
    <div className="gtv-lightbox">
      <button className="gtv-lightbox__close" onClick={onClose} aria-label="Close">×</button>
      <button className="gtv-lightbox__nav gtv-lightbox__nav--prev" onClick={onPrev} aria-label="Previous">‹</button>
      <img className="gtv-lightbox__img" src={images[index]} alt={`Preview ${index + 1}`} />
      <button className="gtv-lightbox__nav gtv-lightbox__nav--next" onClick={onNext} aria-label="Next">›</button>
      <div className="gtv-lightbox__counter">{index + 1} / {images.length}</div>
    </div>
  );
}
function TravelersConversation({ sender, receiver, summary_chats, groupChat, order_id, successAlert, errorAlert, all_messages, is_all_messages, usersMap, getTravelersList
,
  allMessageHandler,      // ✅ add this
  setSelectedSender       // ✅ add this
  , selectedSender, is_allow_one_to_one_chat, is_all_groups, groups

 }) {
    const [chat, setChat] = useState([]);
    const [selectAll, setSelectAll] = useState(false);
    const [disableDelete, setDeleteToggle] = useState(true);

    // Lightbox state
    const [lightboxOpen, setLightboxOpen] = useState(false);
    const [lightboxImages, setLightboxImages] = useState([]);
    const [lightboxIndex, setLightboxIndex] = useState(0);

    // Create a list of all image URLs in chat
    const allChatImages = React.useMemo(
        () => chat.filter(m => m.imageUrl).map(m => m.imageUrl),
        [chat]
    );

    async function getChat() {
        try {
            let data = {
                order_id: order_id,
                sender_id: sender ? sender.id : '',
                receiver_id: receiver ? receiver.id : '',
                group_chat_id: groupChat ? groupChat.id : ''
            }
            let res = await orderService.getOrderChat(data);
            let chatData = [...res.result.data.map(item => ({ ...item, selected: false }))];
            chatData.sort((a, b) => new Date(a.timestamp) - new Date(b.timestamp));
            setChat(chatData);
        } catch (e) {
            console.log('Error in listing', e);
        }
    }

    useEffect(() => {
        if (receiver) getChat();
    }, [receiver]);

    useEffect(() => {
        if (groupChat) getChat();
    }, [groupChat]);

    useEffect(() => {
        if (is_all_messages && all_messages) {
            setChat(all_messages);
        }
    }, [is_all_messages, all_messages]);

    useEffect(() => {
        if (is_all_groups && groups) {
            setChat(groups);
        }
    }, [is_all_groups, groups]);


    useEffect(() => {
        if (chat.length > 0) {
            setDeleteToggle(!chat.some(item => item.selected));
        }
        setSelectAll(false);
    }, [chat.length]);

    useEffect(() => {
        if (chat.length > 0) {
            setDeleteToggle(!chat.some(item => item.selected));
        }
    }, [chat]);

    function markMessage(e, index) {
        let chatTemp = [...chat];
        chatTemp[index].selected = e.target.checked;
        setChat(chatTemp);
    }

    function confrimDeleteMessages() {
        confirmAlert({
            customUI: ({ onClose }) => (
                <ConfirmAlertForDelete
                    typeName="Message"
                    description="Are you sure to delete these messages?"
                    onClosePro={onClose}
                    deleteType={() => { deleteMessages() }}
                />
            )
        })
    }

    async function deleteMessages() {
        try {
            let messages = chat.filter(msg => msg.selected).map(msg => msg.path);
            const data = {
                messages,
                order_id,
                sender_id: sender ? sender.id : '',
                receiver_id: receiver ? receiver.id : '',
                group_chat_id: groupChat ? groupChat.id : ''
            };
            if (messages.length > 0) {
                const res = await orderService.deleteMessages({ ...data });
                successAlert(res.message);
                setSelectAll(false);
                if (is_all_messages) {
                    getTravelersList();
                    // Keep all messages, but mark the selected ones as deleted
                    const updatedChat = filteredChat.map(msg =>
                        msg.selected ? { ...msg, deleted_at: Date.now() } : msg
                    );
                    setChat(updatedChat);
                } else {
                    getChat();
                }

            }
        } catch (e) {
            console.log("Delete error:", e)
            errorAlert(e);
        }
    }

    async function markAllMessages(e) {
        let chatTemp = filteredChat.map(item => ({ ...item, selected: e.target.checked }));
        setSelectAll(e.target.checked);
        setChat(chatTemp);
    }

    function formatAMPM(date) {
        var hours = date.getHours();
        var minutes = date.getMinutes();
        var ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12 || 12;
        minutes = minutes < 10 ? '0' + minutes : minutes;
        return hours + ':' + minutes + ' ' + ampm;
    }

    function renderDateTimeString(t) {
        if (t) {
            let dateObj = new Date(t);
            let dateStr = dateObj.toDateString();
            let dateArr = dateStr.split(' ');
            dateArr[2] = `${dateArr[2]}, `;
            return dateArr.join(' ') + ' ' + formatAMPM(dateObj);
        }
    }

    const openLightbox = useCallback((startIndex = 0) => {
        setLightboxImages(allChatImages);
        setLightboxIndex(startIndex);
        setLightboxOpen(true);
    }, [allChatImages]);

    const closeLightbox = useCallback(() => setLightboxOpen(false), []);
    const prevLightbox = useCallback(
        () => setLightboxIndex(i => (i - 1 + lightboxImages.length) % lightboxImages.length),
        [lightboxImages.length]
    );
    const nextLightbox = useCallback(
        () => setLightboxIndex(i => (i + 1) % lightboxImages.length),
        [lightboxImages.length]
    );

    // 🔹 Filter messages by selected sender if provided from parent
    // ✅ Filter messages when in "All Messages" tab
    const filteredChat = React.useMemo(() => {
    if (is_all_messages) {
        // If a specific sender is selected, show only that sender's messages
        if (selectedSender) {
            return chat.filter(msg => msg.sent_by === selectedSender.id);
        }
        // Otherwise show all messages
        return chat;
    }
    // In other tabs, show normal chat
    return chat;
    }, [chat, selectedSender, is_all_messages]);


    return (
        <div className="groupTravelers">
            {
                ((sender && receiver) || groupChat || (is_all_messages && all_messages) || (is_all_groups && groups)) &&
                <div id="chat-box-container">
                    <div style={{ display: "flex", justifyContent: 'space-between', alignItems: 'center' }}>
                            <div className="chat-user-info">
                                <div>
                                    <img src={avatar} alt="avatar" />
                                </div>
                                {
                                    groupChat ?
                                        <div>
                                            <div>
                                                {groupChat.group_name}
                                            </div>
                                            <div>
                                                <strong>All Messages</strong>
                                            </div>
                                        </div>
                                        :
                                            is_all_messages ?
                                            <div>
                                                {
                                                    all_messages.length > 0 ?
                                                    <>
                                                        <div>
                                                            {/* {all_messages && all_messages[0].sender_first_name} {all_messages && all_messages[0].sender_last_name} */}
                                                            {selectedSender && selectedSender.firstName} {selectedSender &&selectedSender.lastName}
                                                        </div>
                                                        <div>
                                                            <strong>{is_allow_one_to_one_chat ? 'Message All' : 'Announcements'}</strong>
                                                        </div>
                                                    </>
                                                    :
                                                    <div>
                                                        <strong>{is_allow_one_to_one_chat ? 'Message All' : 'Announcements'}</strong>
                                                    </div>
                                                }
                                            </div>
                                            :
                                            <div>
                                                <div>
                                                    {sender.deleted_at && sender.deleted_at > 1 ?
                                                        <del style={{color:"#999"}}>{sender.firstName} {sender.lastName}</del>
                                                        :
                                                        <div>{sender.firstName} {sender.lastName}</div>
                                                    }
                                                    {receiver.deleted_at && receiver.deleted_at > 1 ?
                                                        <del style={{color:"#999"}}>{receiver.firstName} {receiver.lastName}</del>
                                                        :
                                                        <div>{receiver.firstName} {receiver.lastName}</div>
                                                    }
                                                </div>
                                                <div>
                                                    <strong>All Messages</strong>
                                                </div>
                                            </div>
                                }
                            </div>
                        {
                            // !is_all_messages &&
                            <div style={{ display: 'flex', gap: '20px', paddingRight: '20px' }}>
                                <div>
                                    <span onClick={confrimDeleteMessages} style={{ cursor: 'pointer', pointerEvents: `${disableDelete ? 'none' : 'auto'}` }}>
                                        <img src={trashIcon} alt="Delete Chat" style={{ filter: `opacity(${disableDelete ? 0.5 : 1})` }} />
                                    </span>
                                </div>
                                <div>
                                    <label className="container-check">
                                        <input type="checkbox" name={'deleteText'}
                                            className="checkbox"
                                            onChange={markAllMessages} checked={selectAll}
                                        />
                                        <span className="checkmark"></span>
                                    </label>
                                </div>
                            </div>
                        }
                    </div>
                    <hr />
                    <div className="conversation-container">
                        {
                            filteredChat.length > 0 ? filteredChat.map((data, index) => {
                                const isImage = !!data.imageUrl;
                                const imageIndex = isImage ? allChatImages.indexOf(data.imageUrl) : -1;

                                return (
                                    <div key={data.timestamp} className={`${data.deleted_at && data.deleted_at > 1 && "bgDelete"}`}>
                                        {/* Sender label */}
                                        {groupChat || is_all_messages
                                            ? <div className="chatPurple"
                                                // log={console.log('data.sender_last_name',(is_all_messages && data.message === 'Testing ') && data)}
                                                >

                                                {usersMap[data.sent_by] && usersMap[data.sent_by].deleted_at && usersMap[data.sent_by].deleted_at > 1 ?
                                                    <del style={{color:"#999"}}>{data.sender_first_name}  {data.sender_last_name}</del>
                                                    :
                                                    <div>{data.sender_first_name + ' ' + data.sender_last_name}</div>
                                                }
                                            </div>
                                            : <div className={data.sent_by === sender.id ? 'chatPurple' : 'chatGrey'}>
                                                {data.sent_by === sender.id
                                                    ?
                                                        sender.deleted_at && sender.deleted_at > 1 ?
                                                        <del style={{color:"#999"}}>{sender.firstName}  {sender.lastName}</del>
                                                        :
                                                        <div>{sender.firstName}  {sender.lastName}</div>
                                                    :
                                                        receiver.deleted_at && receiver.deleted_at > 1 ?
                                                        <del style={{color:"#999"}}>{receiver.firstName}  {receiver.lastName}</del>
                                                        :
                                                        <div>{receiver.firstName}  {receiver.lastName}</div>
                                                }
                                              </div>
                                        }

                                        {/* Message bubble */}
                                        <div style={{ display: 'flex' }}>
                                            <div
                                                className={groupChat || is_all_messages
                                                    ? 'messageSenderPurple'
                                                    : data.sent_by === sender.id
                                                        ? 'messageSenderPurple'
                                                        : 'messageSender'}
                                                style={{
                                                    background: groupChat || is_all_messages
                                                        ? '#8A288F'
                                                        : data.sent_by === sender.id ? '#8A288F' : '#F2F2F2',
                                                    color: groupChat || is_all_messages
                                                        ? 'white'
                                                        : data.sent_by === sender.id ? 'white' : '#212121',
                                                }}
                                            >
                                                <div>
                                                    {data.message
                                                        ? data.message
                                                        : isImage
                                                            ? <img
                                                                src={data.imageUrl}
                                                                alt=""
                                                                style={{ cursor: 'pointer' }}
                                                                onClick={() => openLightbox(imageIndex)}
                                                                />
                                                            : ""}
                                                </div>
                                            </div>

                                            {/* Checkbox */}
                                            <div style={{ width: '5%', paddingTop: '5px' }}>
                                            {!(data.deleted_at || (data.deleted_at && data.deleted_at < 1)) &&
                                                <label className="container-check">
                                                    <input type="checkbox"
                                                        name={'deleteText'}
                                                        className="checkbox"
                                                        onChange={(e) => { markMessage(e, index) }}
                                                        checked={data.selected}
                                                    />
                                                    <span className="checkmark"></span>
                                                </label>
                                            }
                                            </div>
                                        </div>

                                        <small className={groupChat || is_all_messages
                                            ? 'chatPurple'
                                            : data.sent_by === sender.id ? 'chatPurple' : 'chatGrey'}>
                                            {renderDateTimeString(data.timestamp)}
                                        </small>
                                    </div>
                                )
                            }) : 'No Messages Found!'
                        }
                    </div>
                </div>
            }
            <Lightbox
                open={lightboxOpen}
                images={lightboxImages}
                index={lightboxIndex}
                onClose={closeLightbox}
                onPrev={prevLightbox}
                onNext={nextLightbox}
            />
        </div>
    );
}

const mapDispatchToProps = dispatch => {
    return ({
        errorAlert: (e) => {
            dispatch(alertActions.error(e))
        },
        successAlert: (msg) => {
            dispatch(alertActions.success(msg))
        },
    });
};

export default withRouter(connect(null, mapDispatchToProps)(TravelersConversation));
